import { render, staticRenderFns } from "./SelectCourse.vue?vue&type=template&id=1d8852cb&scoped=true"
import script from "./SelectCourse.vue?vue&type=script&lang=js"
export * from "./SelectCourse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8852cb",
  null
  
)

export default component.exports